import { USER_STATUSES } from '../constants';
import gettext from '../lang/gettext';

export default function getUserStatusText(user) {
  if (user.status === USER_STATUSES.REQUESTED_INVITE) {
    return gettext('Requested');
  }

  if (user.status === USER_STATUSES.UNINVITED) {
    return user.missingInviteDetails ? gettext('Missing details') : gettext('Not invited');
  }

  if (user.status === USER_STATUSES.INVITED) {
    return gettext('Invited');
  }

  if (user.pending) {
    return gettext('Unverified');
  }

  if (user.status === USER_STATUSES.VERIFIED && user.active) {
    return gettext('Joined');
  }

  if (!user.active) {
    return gettext('Deactivated');
  }

  return user.statusText;
}
